import * as React from 'react';
import {flow, isUndefined, each, get} from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, ControlLabel, Form, FormGroup, Row} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {IChannel, ICustomer, IPostcodeAddress, IProduct} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import TitleField from '../../../../components/TitleField';
import {
  isFutureDate, isRequired, isValidDate, annualLimit, isPostcode, normalizeYear, isNotShorterThan,
  minAge, maxAge, isValidDob,
} from '../../../../util/validators';
import * as moment from 'moment';
import FieldFormControl from '../../../../components/FieldFormControl';
import AddressLookUp from '../../../../components/AddressLookUp';
import FaCheck from 'react-icons/fa/check';
import * as uuid from 'uuid/v4';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker';

interface IProposerFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  endDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  customerType: string;
  insured: ICustomer;
  postcode: string;
}

interface IProposerFormState {
  declines: any[];
  referrals: any[];
  errors: any[];
  showStartDateField: boolean;
  showLicenceDate: boolean;
}

class ProposerForm extends React.Component<IProposerFormProps, IProposerFormState> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    showStartDateField: false,
    showLicenceDate: false,
  };

  public componentDidMount() {
    const { insured, startDate, dispatch, change } = this.props;

    if (!isUndefined(insured) && insured.firstName === 'Test') {
      dispatch(change('insured.firstName', ''));
    }

    if (!isUndefined(insured) && insured.lastName === 'Test') {
      dispatch(change('insured.lastName', ''));
    }

    if (!isUndefined(startDate) && startDate) {
      this.setState({ showStartDateField: !!startDate });
    }

    if (!isUndefined(insured) && !isUndefined(insured.metadata.lengthOfLicence) && insured.metadata.lengthOfLicence) {
      this.setState({ showLicenceDate: true });
    }

    this.updateProposerDriver(this.props);
  }

  public componentWillReceiveProps(nextProps) {
    const { customerType, insured, postcode, dispatch, change } = this.props;

    if (!isUndefined(insured) && (customerType !== nextProps.customerType ||
      insured.firstName !== nextProps.insured.firstName ||
      insured.lastName !== nextProps.insured.lastName ||
      insured.dob !== nextProps.insured.dob ||
      insured.metadata.typeOfLicence !== nextProps.insured.metadata.typeOfLicence ||
      insured.metadata.lengthOfLicence !== nextProps.insured.metadata.lengthOfLicence
    )) {
      this.updateProposerDriver(nextProps);
    }

    if (postcode !== nextProps.postcode) {
      this.checkPostcodeReferral(nextProps.postcode);
    }
  }

  private checkPostcodeReferral(postcode) {
    const { quote, dispatch, change } = this.props;
    const postcodeRules = get(quote, 'quotes.standard.annual.scheme.metadata.postcodes', {});

    let decline = false;
    let refer = true;

    if (postcode === null) {
      return;
    }

    let outwardCode = postcode.match(/[A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]?/);
    if (!outwardCode) {
      return;
    }
    outwardCode = outwardCode[0].toUpperCase();

    each(postcodeRules.decline, (value) => {
      if (outwardCode === value) {
        decline = true;
      }
    });

    each(postcodeRules.accept, (value) => {
      if (outwardCode === value) {
        refer = false;
      }
    });

    if (decline) {
      dispatch(change('postcodeReferrals.decline', true));
      dispatch(change('postcodeReferrals.refer', false));
    } else if (refer) {
      dispatch(change('postcodeReferrals.refer', true));
      dispatch(change('postcodeReferrals.decline', false));
    } else {
      dispatch(change('postcodeReferrals.decline', false));
      dispatch(change('postcodeReferrals.refer', false));
    }
  }

  private updateProposerDriver(nextProps) {
    const { dispatch, change, drivers, personalCustomer, insured } = nextProps;

    let proposerDriverIndex = -1;
    each(drivers, (driver, key) => {
      if (driver.proposer) {
        proposerDriverIndex = parseInt(key, 10);
        return;
      }
    });

    if (personalCustomer) {
      if (proposerDriverIndex > -1) {
        drivers[proposerDriverIndex] = {
          id: drivers[proposerDriverIndex].id,
          title: insured.title,
          firstName: insured.firstName,
          lastName: insured.lastName,
          dob: insured.dob,
          proposer: true,
          lengthOfLicence: insured.metadata.lengthOfLicence,
          typeOfLicence: insured.metadata.typeOfLicence,
        };
      } else {
        const proposerDriver = {
          id: uuid(),
          title: insured.title,
          firstName: insured.firstName,
          lastName: insured.lastName,
          dob: insured.dob,
          proposer: true,
          lengthOfLicence: '',
          typeOfLicence: '',
        };
        drivers.push(proposerDriver);
        dispatch(change('driverCount', drivers.length));
      }
    } else {
      if (proposerDriverIndex > -1) {
        drivers.splice(proposerDriverIndex, 1);
        dispatch(change('driverCount', drivers.length));
      }
    }
  }

  private updateEndDate = (event, date) => {
    const { dispatch, change } = this.props;

    const newStartDate = date ? moment(date, 'DD/MM/YYYY') : '';
    const newEndDate = newStartDate ? newStartDate.add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD') : null;

    dispatch(change('endDate', newEndDate));
  }

  private updateCustomerType = (event) => {
    const { dispatch, change } = this.props;

    dispatch(change('personalCustomer', event.target.value === 'individual' ? true : false));

    if (event.target.value === 'company') {
      dispatch(change('insured.dob', ''));
    }
    if (event.target.value === 'individual') {
      dispatch(change('insured.metadata.microEnterprise', ''));
      dispatch(change('insured.companyName', ''));
      dispatch(change('insured.metadata.tradingName', ''));
      dispatch(change('insured.metadata.companyRegistrationNumber', ''));
      dispatch(change('insured.metadata.year', ''));
    }
    if (event.target.value === 'joint') {
      dispatch(change('insured.metadata.microEnterprise', ''));
      dispatch(change('insured.metadata.year', ''));
      dispatch(change('insured.dob', ''));
      dispatch(change('insured.metadata.year', ''));
    }
  }

  private updateLicenceSelection = (event) => {
    const { dispatch, change } = this.props;

    if (event.target.value === 'date') {
      this.setState({ showLicenceDate: true });
    } else {
      this.setState({ showLicenceDate: false });
      dispatch(change('insured.metadata.lengthOfLicence', ''));
    }

    switch (event.target.value) {
      case 'date':
        dispatch(change('insured.metadata.typeOfLicence', 'Unknown'));
        break;
      case 'provisional':
        dispatch(change('insured.metadata.typeOfLicence', 'Provisional (UK) Car Licence'));
        break;
      case 'none':
        dispatch(change('insured.metadata.typeOfLicence', 'No Licence Held'));
        break;
    }
  }

  private updateStartDateStateTrue = () => {
    const { dispatch, change } = this.props;

    dispatch(change('startDate', ''));
    this.setState({ showStartDateField: true });
  }

  private updateStartDateStateFalse = (event) => {
    const { dispatch, change } = this.props;

    if (!isUndefined((event.target.value))) {
      dispatch(change('startDate', event.target.value));
    }
    this.setState({ showStartDateField: false });
    this.updateEndDate(event, event.target.value);
  }

  private handleSelectAddress = (address: IPostcodeAddress) => {
    const { dispatch, change } = this.props;

    dispatch(change('insured.address.line1', address.line1));
    dispatch(change('insured.address.line2', address.line2));
    dispatch(change('insured.address.town', address.town));
    dispatch(change('insured.address.county', address.county));
    dispatch(change('insured.address.postcode', address.postcode));
  }

  private renderPersonalName() {
    return (
      <>
        <FormGroup controlId={'customer'}>
          <div className="row-names">
            <div>
              <Col componentClass={ControlLabel} sm={6}>
                What is your name?
              </Col>
              <Col
                sm={3}
                style={{ paddingBottom: '9px' }}
                className="title-width"
              >
                <TitleField
                  name={'insured.title'}
                  validate={[ isRequired ]}
                  type="adult"
                />
              </Col>
            </div>
            <div className="row-names">
              <Col smOffset={6} sm={4} style={{ paddingBottom: '9px' }}>
                <Field
                  type="text"
                  placeholder="Forename"
                  name={'insured.firstName'}
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </div>
            <div className="row-names">
              <Col smOffset={6} sm={4} style={{ paddingBottom: '9px' }}>
                <Field
                  type="text"
                  placeholder="Surname"
                  name={'insured.lastName'}
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </div>
          </div>
        </FormGroup>
      </>
    );
  }

  private renderMicroEnterprise() {
    const { renderDefinition } = this.props;

    return (
      <>
        <FormGroup controlId="micro_enterprise">
          <Col sm={6}>
            {renderDefinition('b2c_proposer_micro_enterprise')}
            Are you a micro enterprise?
          </Col>
          <Col sm={6}>
            <Col sm={12}>
              <Row className="button-group-container">
                <Col sm={6} className="button-group-btn-container no-padding-horizontal unpadded">
                  <Field
                    name="insured.metadata.microEnterprise"
                    type="radio"
                    value="false"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      No
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
                <Col sm={6} className="button-group-btn-container no-padding-horizontal unpadded">
                  <Field
                    name="insured.metadata.microEnterprise"
                    type="radio"
                    value="true"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn'}>
                      Yes
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Col>
        </FormGroup>
      </>
    );
  }

  private renderCompanyName(title, placeholder) {
    const { renderDefinition } = this.props;

    return (
      <>
        <FormGroup controlId={'company_name'}>
          <Col componentClass={ControlLabel} sm={6}>
            {title}
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    name={'insured.companyName'}
                    component={FieldFormControl}
                    validate={[isRequired]}
                    placeholder={placeholder}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>
        {this.props.insured.companyName && (
          <FormGroup controlId={'company_registration_number'}>
            <Col componentClass={ControlLabel} sm={6}>
              {renderDefinition('b2c_proposer_company_registration_number')}
              Please enter the company registration number:
            </Col>
            <Col sm={6}>
              <div className="full-name-fields">
                <Row>
                  <Col sm={12}>
                    <Field
                      type="text"
                      name={'insured.metadata.companyRegistrationNumber'}
                      component={FieldFormControl}
                      placeholder="Company Registration Number"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </FormGroup>
        )}
        {this.props.insured.companyName && (
          <FormGroup controlId={'trading_name'}>
            <Col componentClass={ControlLabel} sm={6}>
              Please enter the trading name (if there is one):
            </Col>
            <Col sm={6}>
              <div className="full-name-fields">
                <Row>
                  <Col sm={12}>
                    <Field
                      type="text"
                      name={'insured.metadata.tradingName'}
                      component={FieldFormControl}
                      placeholder="Trading Name"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </FormGroup>
        )}
      </>
    );
  }

  private renderPhoneNumber() {
    return (
      <FormGroup controlId={'insured.phone'} >
        <Col componentClass={ControlLabel} sm={6}>
          Please enter your phone number:
        </Col>
        <Col sm={3}>
          <Field
            name={'insured.phone1'}
            component={FieldFormControl}
            validate={[isRequired]}
            placeholder="Phone number"
          />
        </Col>
      </FormGroup>
    );
  }

  private renderDateOfBirth() {
    return (
      <FormGroup controlId="dob">
        <Col componentClass={ControlLabel} sm={6}>
          What is your date of birth?
        </Col>
        <Col sm={6}>
          <div className="alternative-date-picker">
            <div className="field">
              <Field
                name="insured.dob"
                id="insured-dob-text-field"
                type="masked-date"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
              />
            </div>
            <div className="icon">
              <Field
                name="insured.dob"
                maxDate={moment()}
                component={AlternativeDatePicker}
                validate={[
                  isRequired,
                  isValidDob,
                  minAge,
                  maxAge,
                ]}
              />
            </div>
          </div>
        </Col>
      </FormGroup>
    );
  }

  private renderYear() {
    const { renderDefinition } = this.props;

    return (
      <FormGroup controlId={'year'}>
        <Col componentClass={ControlLabel} sm={6}>
          {renderDefinition('b2c_proposer_year')}
          What year was the company established?
        </Col>
        <Col sm={3}>
          <Field
            name={'insured.metadata.year'}
            component={FieldFormControl}
            normalize={normalizeYear}
            validate={[
              isRequired,
              isNotShorterThan(3, 'Please enter a valid year'),
            ]}
            placeholder="YYYY"
          />
        </Col>
      </FormGroup>
    );
  }

  private renderAddress(title) {
    return (
      <>
        <FormGroup controlId="postcode">
          <Col componentClass={ControlLabel} sm={6}>
            {title}
          </Col>
          <Col sm={6}>
            <Field
              name="insured.address.postcode"
              type="text"
              className=""
              component={AddressLookUp}
              onSelectAddress={this.handleSelectAddress}
              validate={[
                isRequired,
                isPostcode,
              ]}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="address">
          <Row className="address-proposer-lines">
            <Col sm={6} className="address-left-padding" />
            <Col sm={6}>
              {this.props.insured.address.line1 ? this.props.insured.address.line1 : ''}
            </Col>
          </Row>
          {this.props.insured.address.line2 && (
            <Row className="address-proposer-lines">
              <Col sm={6} className="address-left-padding" />
              <Col sm={6}>
                {this.props.insured.address.line2 ? this.props.insured.address.line2 : ''}
              </Col>
            </Row>
          )}
          <Row className="address-proposer-lines">
            <Col sm={6} className="address-left-padding" />
            <Col sm={6}>
              {this.props.insured.address.town ? this.props.insured.address.town : ''}
            </Col>
          </Row>
          <Row className="address-proposer-lines">
            <Col sm={6} className="address-left-padding" />
            <Col sm={6}>
              {this.props.insured.address.county ? this.props.insured.address.county : ''}
            </Col>
          </Row>
        </FormGroup>
      </>
    );
  }

  private renderLicence() {
    const { showLicenceDate } = this.state;

    return (
      <>
        <FormGroup controlId={'licence_type'} >
          <Col componentClass={ControlLabel} sm={6}>
            What date did {this.props.insured.firstName} {this.props.insured.lastName} pass their licence for the type
            of vehicle being driven?
          </Col>
          <Col sm={6}>
            <Col sm={12}>
              {!showLicenceDate && (
                <Row className="button-group-container">
                  <Col sm={12} className="other-input">
                    <Field
                      name="licenceSelection"
                      type="radio"
                      value={'date'}
                      component={FieldFormControl}
                      onChange={this.updateLicenceSelection}
                      validate={[isRequired]}
                    >
                      <div className={'button-group-btn-alt'}>
                        <span />
                        Date
                      </div>
                    </Field>
                  </Col>
                </Row>
              )}
              {showLicenceDate && (
                <Row>
                  <Col sm={12}
                       className="button-group-btn-container input-alt vehicle-info-centre">
                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name="insured.metadata.lengthOfLicence"
                          id="length-of-licence-text-field"
                          type="masked-date"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name="insured.metadata.lengthOfLicence"
                          maxDate={moment()}
                          component={AlternativeDatePicker}
                          validate={[
                            isRequired,
                            isValidDate,
                          ]}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="button-group-container">
                <Col sm={12} className="input-alt">
                  <Field
                    name="licenceSelection"
                    type="radio"
                    value={'provisional'}
                    onChange={this.updateLicenceSelection}
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn-alt'}>
                      <span />
                      <div className="visible-lg-inline">No test passed -</div>&nbsp;Provisional licence held
                    </div>
                  </Field>
                </Col>
              </Row>
              <Row className="button-group-container">
                <Col sm={12} className="input-alt">
                  <Field
                    name="licenceSelection"
                    type="radio"
                    value={'none'}
                    component={FieldFormControl}
                    onChange={this.updateLicenceSelection}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn-alt'}>
                      <span />
                      No valid driving licence held
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Col>
        </FormGroup>
      </>
    );
  }

  // public renderHorseboxDeclaration() {
  //   return (
  //     <FormGroup controlId={'declaration.17'}>
  //       <Col componentClass={ControlLabel} sm={6}>
  //         Have you regularly driven a horsebox or similar size commercial vehicle during the past 2 years?
  //       </Col>
  //       <Col sm={6}>
  //         <Col sm={12}>
  //           <Row className="button-group-container">
  //             <Col sm={6} className="button-group-btn-container no-padding-horizontal">
  //               <Field
  //                 name="declarationQuestion[17]"
  //                 type="radio"
  //                 value="false"
  //                 component={FieldFormControl}
  //                 validate={[isRequired]}
  //               >
  //                 <div className={'button-group-btn'}>
  //                   No
  //                   <FaCheck/>
  //                 </div>
  //               </Field>
  //             </Col>
  //             <Col sm={6} className="button-group-btn-container no-padding-horizontal">
  //               <Field
  //                 name="declarationQuestion[17]"
  //                 type="radio"
  //                 value="true"
  //                 component={FieldFormControl}
  //                 validate={[isRequired]}
  //               >
  //                 <div className={'button-group-btn'}>
  //                   Yes
  //                   <FaCheck/>
  //                 </div>
  //               </Field>
  //             </Col>
  //           </Row>
  //         </Col>
  //       </Col>
  //     </FormGroup>
  //   );
  // }

  public render() {
    const { handleSubmit, customerType, renewal } = this.props;
    const { showStartDateField } = this.state;

    // Only enable next button if address line 1 set
    let nextButtonDisabled = true;
    if (this.props.insured && this.props.insured.address.line1) {
      nextButtonDisabled = false;
    }

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <div className="sub-content-container">
            {renewal ? (
              <FormGroup controlId={'start_date'} >
                <Col componentClass={ControlLabel} sm={6}>
                  Renewal Date
                </Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={12}
                         className="button-group-btn-container input-alt vehicle-info-centre">
                      <div className="alternative-date-picker">
                        <div className="field">
                          <Field
                            name="startDate"
                            id="start-date-text-field"
                            type="masked-date"
                            placeholder="dd/mm/yyyy"
                            component={FieldFormControl}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
            ) : (
              <FormGroup controlId={'start_date'} >
                <Col componentClass={ControlLabel} sm={6}>
                  When would you like your cover to start?
                </Col>
                <Col sm={6}>
                  <Col sm={12}>
                    <Row className="button-group-container">
                      <Col sm={12} className="input-alt">
                        <Field
                          name="dateToStart"
                          type="radio"
                          value={moment().format('DD/MM/YYYY')}
                          component={FieldFormControl}
                          onChange={this.updateStartDateStateFalse}
                          validate={[isRequired]}
                        >
                          <div className={'button-group-btn-alt'}>
                            <span />
                            Today ({moment().format('Do MMMM YYYY')})
                          </div>
                        </Field>
                      </Col>
                    </Row>
                    <Row className="button-group-container">
                      <Col sm={12} className="input-alt">
                        <Field
                          name="dateToStart"
                          type="radio"
                          value={moment().add('1', 'days').format('DD/MM/YYYY')}
                          onChange={this.updateStartDateStateFalse}
                          component={FieldFormControl}
                          validate={[isRequired]}
                        >
                          <div className={'button-group-btn-alt'}>
                            <span />
                            Tomorrow ({moment().add('1', 'days').format('Do MMMM YYYY')})
                          </div>
                        </Field>
                      </Col>
                    </Row>
                    {!showStartDateField && (
                      <Row className="button-group-container">
                        <Col sm={12} className="other-input">
                          <Field
                            name="dateToStart"
                            type="radio"
                            value={false}
                            component={FieldFormControl}
                            onChange={this.updateStartDateStateTrue}
                            validate={[isRequired]}
                          >
                            <div className={'button-group-btn-alt'}>
                              <span />
                              Other
                            </div>
                          </Field>
                        </Col>
                      </Row>
                    )}
                    {showStartDateField && (
                      <Row>
                        <Col sm={12}
                             className="button-group-btn-container input-alt vehicle-info-centre">
                          <div className="alternative-date-picker">
                            <div className="field">
                              <Field
                                name="startDate"
                                id="start-date-text-field"
                                type="masked-date"
                                placeholder="dd/mm/yyyy"
                                component={FieldFormControl}
                                readOnly={true}
                              />
                            </div>
                            <div className="icon">
                              <Field
                                name="startDate"
                                minDate={moment()}
                                maxDate={moment().add('45', 'days')}
                                component={AlternativeDatePicker}
                                onChange={this.updateEndDate}
                                validate={[
                                  isRequired,
                                  isFutureDate,
                                  isValidDate,
                                  annualLimit,
                                ]}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Col>
              </FormGroup>
            )}
            {(this.props.startDate || customerType !== '') && (
              <FormGroup controlId="customer_type">
                <Col sm={6} style={{ paddingTop: '9px', paddingRight: '10px' }}>
                  Is the proposer a Company, an Individual or in Joint Names?
                </Col>
                <Col sm={6}>
                  <Col sm={12}>
                    <Row className="button-group-container">
                      <Col sm={4} className="button-group-btn-container no-padding-horizontal wide unpadded">
                        <Field
                          name="customerType"
                          type="radio"
                          value="company"
                          component={FieldFormControl}
                          onChange={this.updateCustomerType}
                          validate={[isRequired]}
                        >
                          <div className={'button-group-btn wide'}>
                            Company
                            <FaCheck />
                          </div>
                        </Field>
                      </Col>
                      <Col sm={4} className="button-group-btn-container no-padding-horizontal wide unpadded">
                        <Field
                          name="customerType"
                          type="radio"
                          value="individual"
                          component={FieldFormControl}
                          onChange={this.updateCustomerType}
                          validate={[isRequired]}
                        >
                          <div className={'button-group-btn wide'}>
                            Individual
                            <FaCheck />
                          </div>
                        </Field>
                      </Col>
                      <Col sm={4} className="button-group-btn-container no-padding-horizontal wide unpadded">
                        <Field
                          name="customerType"
                          type="radio"
                          value="joint"
                          component={FieldFormControl}
                          onChange={this.updateCustomerType}
                          validate={[isRequired]}
                        >
                          <div className={'button-group-btn wide'}>
                            Joint
                            <FaCheck />
                          </div>
                        </Field>
                      </Col>
                    </Row>
                  </Col>
                </Col>
              </FormGroup>
            )}

            {customerType === 'company' && (
              <div>
                {this.renderPersonalName()}
                {this.props.insured.lastName && (
                  <>
                    {this.renderMicroEnterprise()}
                  </>
                )}
                {this.props.insured.metadata.microEnterprise && (
                  <>
                    {this.renderCompanyName('What is the name of the company?', 'Company Name')}
                  </>
                )}
                {this.props.insured.companyName && (
                  <>
                    {this.renderPhoneNumber()}
                  </>
                )}
                {this.props.insured.phone1 && (
                  <>
                    {this.renderYear()}
                  </>
                )}
                {this.props.insured.metadata.year && (
                  <>
                    {this.renderAddress('What is the company address?')}
                  </>
                )}
              </div>
            )}

            {customerType === 'individual' && (
              <div>
                {this.renderPersonalName()}
                {this.props.insured.lastName && (
                  <>
                    {this.renderDateOfBirth()}
                  </>
                )}
                {this.props.insured.dob && (
                  <>
                    {this.renderPhoneNumber()}
                  </>
                )}
                {this.props.insured.phone1 && (
                  <>
                    {this.renderLicence()}
                  </>
                )}
                {this.props.insured.metadata.typeOfLicence && (
                  <>
                    {this.renderAddress('What is your correspondence postcode?')}
                  </>
                )}
              </div>
            )}

            {customerType === 'joint' && (
              <div>
                {this.renderPersonalName()}
                {this.props.insured.lastName && (
                  <>
                    {this.renderCompanyName('Who is the policy in the name(s) of?', 'Names')}
                  </>
                )}
                {this.props.insured.companyName && (
                  <>
                    {this.renderPhoneNumber()}
                  </>
                )}
                {this.props.insured.phone1 && (
                  <>
                    {this.renderAddress('What is your correspondence postcode?')}
                  </>
                )}
              </div>
            )}

            {/*{this.props.insured.address.line1 && (*/}
            {/*  <>*/}
            {/*    {this.renderHorseboxDeclaration()}*/}
            {/*  </>*/}
            {/*)}*/}
          </div>
          <NavigationBar
            hasBackButton={true}
            backTo={'/'}
            {...this.props}
            nextButtonDisabled={nextButtonDisabled}
            hasSaveButton={true}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const personalCustomer = selector(state, 'personalCustomer');
      const customerType = selector(state, 'customerType');
      const insured = selector(state, 'insured');
      const drivers = selector(state, 'drivers');
      const postcode = selector(state, 'insured.address.postcode');

      return {
        startDate,
        endDate,
        quotationTypes,
        personalCustomer,
        customerType,
        insured,
        drivers,
        postcode,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(ProposerForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Proposer/index.tsx